import { NavLink, useMatch, useSearchParams } from 'react-router-dom'
import { useI18n } from '../i18n'
import type { Category } from '../types'

const categories: { id: Category | ''; icon: string }[] = [
  { id: '', icon: '🎮' },
  { id: 'puzzle', icon: '🧩' },
  { id: 'arcade', icon: '👾' },
  { id: 'casual', icon: '🍭' },
  { id: 'reflex', icon: '⚡' },
]

export default function CategoryNav({ mobile = false }: { mobile?: boolean }) {
  const { t } = useI18n()
  const [params] = useSearchParams()
  const categoryRoute = useMatch('/games/:category')
  const active = categoryRoute?.params.category || params.get('cat') || ''
  return <nav className={mobile ? 'mobile-categories' : 'category-nav'} aria-label="Game categories">
    {!mobile && <p className="side-title">{t('games')}</p>}
    {categories.map(category => <NavLink
      key={category.id || 'all'}
      to={category.id ? `/games/${category.id}` : '/games'}
      end
      className={({ isActive }) => `${mobile ? 'mobile-category' : 'side-link'} ${isActive && active === category.id ? 'active' : ''}`}
    >
      <span aria-hidden="true">{category.icon}</span>
      <span>{category.id ? t(category.id) : t('all')}</span>
    </NavLink>)}
  </nav>
}
